<template>
  <div class="matrix__wrapper">
    <div class="ws-textbox">
      <div class="title-right-on-arabic" :style="{ float: direction == 'rtl' ? 'right' : 'left' }">
        {{ titleMatrix }}
      </div>
      <div>
        <table class="matrix-table mx-auto my-auto table-responsive">
          <thead>
            <tr>
              <td></td>
              <td v-for="n in number" :key="n" class="padding-td" align="center">
                {{ n }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(pax, index) in listPaxs" :key="index">
              <td class="pax-fullname">
                {{ pax.first_name + ' ' + pax.last_name }}
              </td>
              <template v-if="!isInfant(pax)">
                <td v-for="n in number" :key="n" align="center" class="padding-td">
                  <input
                    type="radio"
                    :name="'room-' + pax.passenger_id"
                    :checked="dataSelect[index] == n"
                    :value="n"
                    @change="handleSelectMatrix(index, $event)"
                  />
                </td>
              </template>
              <template v-else>
                <td v-for="n in number" :key="n" align="center" class="padding-td">
                  <input id="" type="radio" disabled />
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatrixSelect',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    titleMatrix: {
      type: String,
      default: 'Title'
    },
    number: {
      type: Number,
      default: 1
    },
    isDefaultValue: {
      type: Boolean,
      default: false
    },
    responseFetchMatrixHotels: {
      type: Object,
      default: () => {}
    },
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dataSelect: [],
      listPaxs: [],
      minIndex: 1
    }
  },
  watch: {
    list() {
      if (!this.isDefaultValue) {
        this.renderSelectRadioBtn()
      }
    },
    number() {
      let dataMatrix = _.get(this.responseFetchMatrixHotels, 'data.matrix', {})
      if (this.responseFetchMatrixHotels.success && Object.keys(dataMatrix).length !== 0) {
        return
      }
      this.renderSelectRadioBtn()
    },
    responseFetchMatrixHotels() {
      let dataMatrix = _.get(this.responseFetchMatrixHotels, 'data.matrix', {})
      if (this.responseFetchMatrixHotels.success && Object.keys(dataMatrix).length !== 0) {
        let numberRoom = _.reduce(dataMatrix, (result, value) => result + value, 0)
        let index = 0
        let indexPax = 0
        for (let key in dataMatrix) {
          // first pax check then start with index = 0
          if (!index) {
            this.setDataSelected(index, Number(key) * Number(dataMatrix[key]))
          } else {
            // see the location of the next passenger
            // by taking the last position of the passenger in the first room
            indexPax = Number(Object.keys(dataMatrix)[index - 1]) * Number(Object.values(dataMatrix)[index - 1])
            for (let i = 0; i < Number(dataMatrix[key]); i++) {
              // if i > 0 -> update indexPax
              if (i) {
                indexPax = indexPax + Number(key)
              }
              this.setDataSelected(indexPax, Number(key))
            }
          }
          index++
        }
        this.$emit('handleChangeRoomSelect', { number: numberRoom })
        this.$emit('getListSelected', this.dataSelect)
        return
      }
      this.$router.push({ path: '/no-hotels-available', query: { secret: this.secret } })
    },
    dataSelect() {
      let self = this
      let min = 99999
      //find position min room number from room assigned
      _.forEach(self.dataSelect, (value, index) => {
        if (value < min && !self.isInfant(self.listPaxs[index])) {
          min = value
        }
      })
      if (min !== 99999) {
        self.minIndex = min
      }
      _.forEach(self.listPaxs, (pax, index) => {
        if (self.isInfant(pax)) {
          self.dataSelect[index] = self.minIndex
        }
      })
    }
  },
  mounted() {
    if (!this.isDefaultValue) {
      this.renderSelectRadioBtn()
      return
    }
    this.listPaxs = _.cloneDeep(this.list)
    _.forEach(this.listPaxs, (value, index) => {
      this.$set(this.dataSelect, index, value.room)
    })
    this.$emit('getListSelected', this.dataSelect)
  },
  methods: {
    // paint diagonal line in matrix
    renderSelectRadioBtn() {
      this.listPaxs = _.cloneDeep(this.list)
      for (let index = 0; index < this.listPaxs.length; index++) {
        // check index = 0
        if (!index) {
          this.$set(this.dataSelect, index, index + 1)
          continue
        }
        this.$set(this.dataSelect, index, this.dataSelect[index - 1] + 1)
        // check dataSelect before >= number -> if true come back assign 1
        if (this.dataSelect[index - 1] >= this.number) {
          this.$set(this.dataSelect, index, 1)
        }
      }
      this.$emit('getListSelected', this.dataSelect)
    },
    handleSelectMatrix(index, e) {
      this.$set(this.dataSelect, index, +e.target.value)
      this.$emit('getListSelected', this.dataSelect)
    },
    setDataSelected(index, length) {
      for (let i = 0; i < length; i++) {
        if (!index) {
          this.$set(this.dataSelect, index + i, 1)
          continue
        }
        this.$set(this.dataSelect, index + i, this.dataSelect[index - 1] + 1)
      }
    },
    isInfant(pax) {
      let invoicing_flag = pax.invoicing_flag
      if (pax && !_.isUndefined(pax.invoicing_flag) && !_.isNull(pax.invoicing_flag) && !_.isEmpty(pax.invoicing_flag)) {
        let position = invoicing_flag.search('INFT')
        if (position == -1) {
          position = invoicing_flag.search('INF')
        }
        return position != -1
      } else {
        let ssrs = pax.ssrs
        var v = ssrs.findLastIndex((o) => o.type == 'INFT')
        if (v != -1) {
          return v != -1
        }
        return ssrs.findLastIndex((o) => o.type == 'INF') != -1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.matrix {
  &__wrapper {
    input[type='radio']:checked {
      box-shadow: 0 0 0 2px #00c365;
    }

    input[type='radio']:before {
      content: '';
      display: block;
      width: 60%;
      height: 60%;
      margin: 20% auto;
      border-radius: 50%;
    }

    input[type='radio']:checked:before {
      background: #00c365;
    }
  }

  &-table {
    font-size: 16px;
    border-collapse: inherit;

    .padding-td {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

    .pax-fullname {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      width: 170px;
    }
  }

  &-name ::v-deep {
    width: 150px;
  }
}

input[type='radio'] {
  -webkit-appearance: none;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  outline: none;
  box-shadow: 0 0 0 2px gray;
}
</style>
